module.exports = __webpack_public_path__ + "img/ion_wallet-outline.dd9e6af3.svg";